import { CookieConsentDialog } from "@/components/CookieConsent/CookieConsentDialog";
import { selectedTermsAccepted } from "@/store/slices/termsAcceptedSlice";
import { RootState } from "@/store/store";
import { ReactElement } from "react";
import { useSelector } from "react-redux";

export const CookieGuard = ({
  children,
  showWhileTermsAreUnaccepted
}: {
  children: ReactElement;
  showWhileTermsAreUnaccepted?: boolean;
}) => {
  const termsAccepted = useSelector((state: RootState) => selectedTermsAccepted(state));
  return (
    <>
      {(showWhileTermsAreUnaccepted || termsAccepted) && <CookieConsentDialog />}
      {children}
    </>
  );
};
